export const BUTTON_LABELS = {
  closeIssue: 'Close issue',
  closeIssueWithComment: 'Close with comment',
  closeIssueCompleted: 'Close as completed',
  closeIssueNotPlanned: 'Close as not planned',
}
